import {OpzioniItem} from "../gestversore/types";


export const PrioritaList: OpzioniItem[] = [
  { id: "BASSA",  label: "BASSA" },
  { id: "MEDIA",  label: "MEDIA" },
  { id: "ALTA",  label: "ALTA" },
];


export const FlgDMSList: OpzioniItem[] = [
  { id: "S",  label: "S" },
  { id: "N",  label: "N" },
];


export type PianAtt = {
  id?: number;
  ditta?: number;
  idcli?: string | null;
  codprog?: string;
  codnodo?: string;
  ref?: string;
  datainiziopian?: Date | null;
  datafinepian?: Date | null;
  datainizioeff?: Date | null;
  datafineeff?: Date | null;
  note?: string;
  coddip?: string;
  priorita?: string;
  percomp?: number;
  orepian?: number;
  minpian?: number;
  orainiz?: number;
  mininiz?: number;
  orafine?: number;
  minfine?: number;
};


export type PianAttApiResponse = {
    results: Array<PianAtt>;
    count: number;
};

// Mapping Functions
export function mapJsonToPlanApiResponse(jsonData: any): PianAttApiResponse {
    return {
        count: jsonData.count,
        results: jsonData.results.map((item: any) => ({
            id: item.BT30_ID,
            ditta: item.BT30_DITTA,
            idcli: item.BT30_IDCLI,
            codprog: item.BT30_CODPROG,
            codnodo: item.BT30_CODNODO,
            ref: item.BT30_REF,
            datainiziopian: item.BT30_DATAINIZIOPIAN ? new Date(item.BT30_DATAINIZIOPIAN) : null,
            datafinepian: item.BT30_DATAFINEPIAN ? new Date(item.BT30_DATAFINEPIAN) : null,
            datainizioeff: item.BT30_DATAINIZIOEFF ? new Date(item.BT30_DATAINIZIOEFF) : null,
            datafineeff: item.BT30_DATAFINEEFF ? new Date(item.BT30_DATAFINEEFF) : null,
            note: item.BT30_NOTE,
            coddip: item.BT30_CODDIP,
            priorita: item.BT30_PRIORITA,
            percomp: item.BT30_PERCOMP,
            orepian: item.BT30_OREPIAN,
            minpian: item.BT30_MINPIAN,
            orainiz: item.BT30_ORAINIZ,
            mininiz: item.BT30_MININIZ,
            orafine: item.BT30_ORAFINE,
            minfine: item.BT30_MINFINE,

        }))
    };
}

export function mapPianAttToJson(pianatt: PianAtt) {
    return {
        BT30_ID: pianatt.id,
        BT30_DITTA: pianatt.ditta,
        BT30_IDCLI: pianatt.idcli,
        BT30_CODPROG: pianatt.codprog,
        BT30_CODNODO: pianatt.codnodo,
        BT30_REF: pianatt.ref,
        BT30_DATAINIZIOPIAN: pianatt.datainiziopian,
        BT30_DATAFINEPIAN: pianatt.datafinepian,
        BT30_DATAINIZIOEFF: pianatt.datainizioeff,
        BT30_DATAFINEEFF: pianatt.datafineeff,
        BT30_NOTE: pianatt.note,
        BT30_CODDIP: pianatt.coddip,
        BT30_PRIORITA: pianatt.priorita,
        BT30_PERCOMP: pianatt.percomp,
        BT30_OREPIAN: pianatt.orepian,
        BT30_MINPIAN: pianatt.minpian,
        BT30_ORAINIZ: pianatt.orainiz,
        BT30_MININIZ: pianatt.mininiz,
        BT30_ORAFINE: pianatt.orafine,
        BT30_MINFINE: pianatt.minfine

    };
}

export function mapJsonToPianAtt(jsonData: any): PianAtt {
    return {
        id: jsonData.BT30_ID,
        ditta: jsonData.BT30_DITTA,
        idcli: jsonData.BT30_IDCLI,  // Fixed
        codprog: jsonData.BT30_CODPROG,  // Fixed
        codnodo: jsonData.BT30_CODNODO,  // Fixed
        ref: jsonData.BT30_REF,
        datainiziopian: jsonData.BT30_DATAINIZIOPIAN ? new Date(jsonData.BT30_DATAINIZIOPIAN) : null,
        datafinepian: jsonData.BT30_DATAFINEPIAN ? new Date(jsonData.BT30_DATAFINEPIAN) : null,
        datainizioeff: jsonData.BT30_DATAINIZIOEFF ? new Date(jsonData.BT30_DATAINIZIOEFF) : null,
        datafineeff: jsonData.BT30_DATAFINEEFF ? new Date(jsonData.BT30_DATAFINEEFF) : null,
        note: jsonData.BT30_NOTE,
        coddip: jsonData.BT30_CODDIP,
        priorita: jsonData.BT30_PRIORITA,
        percomp: jsonData.BT30_PERCOMP,
        orepian: jsonData.BT30_OREPIAN,
        minpian: jsonData.BT30_MINPIAN,
        orainiz: jsonData.BT30_ORAINIZ,
        mininiz: jsonData.BT30_MININIZ,
        orafine: jsonData.BT30_ORAFINE,
        minfine: jsonData.BT30_MINFINE,
    };
}


export type PianAttDTO = {
    id?: number;
    ditta?: number;
    idcli?: string;
    desragsoccli?: string;
    codprog?: string;
    desprog?: string;
    codnodo?: string;
    desnodo?: string;
    ref?: string;
    datainiziopian?: Date | null;
    datafinepian?: Date | null;
    datainizioeff?: Date | null;
    datafineeff?: Date | null;
    note?: string;
    coddip?: string;
    priorita?: string;
    percomp?: number;
    orepian?: number;
    minpian?: number;
    nomedip?: string;
    orainiz: number;
    mininiz: number;
    orafine: number;
    minfine: number;
    idprog?: string;

};

export type PianAttDTOApiResponse = {
  results: Array<PianAttDTO>;
  count: number;
};

export function mapJsonToPianAttDTOApiResponse(jsonData: any): PianAttDTOApiResponse {
    return {
        count: jsonData.count,
        results: jsonData.results.map((item: any) => ({
            id: item.VBT30_ID,
            ditta: item.VBT30_DITTA,
            idcli: item.VBT30_IDCLI,
            ragsoccli: item.VBT30_RAGSOCCLI,
            codprog: item.VBT30_CODPROG,
            desprog: item.VBT30_DESPROG,
            codnodo: item.VBT30_CODNODO,
            desnodo: item.VBT30_DESNODO,
            ref: item.VBT30_REF,
            datainiziopian: item.VBT30_DATAINIZIOPIAN ? new Date(item.VBT30_DATAINIZIOPIAN) : null,
            datafinepian: item.VBT30_DATAFINEPIAN ? new Date(item.VBT30_DATAFINEPIAN) : null,
            datainizioeff: item.VBT30_DATAINIZIOEFF ? new Date(item.VBT30_DATAINIZIOEFF) : null,
            datafineeff: item.VBT30_DATAFINEEFF ? new Date(item.VBT30_DATAFINEEFF) : null,
            note: item.VBT30_NOTE,
            coddip: item.VBT30_CODDIP,
            priorita: item.VBT30_PRIORITA,
            percomp: item.VBT30_PERCOMP,
            orepian: item.VBT30_OREPIAN,
            minpian: item.VBT30_MINPIAN,
            nomedip: item.VBT30_NOMEDIP,
            orainiz: item.VBT30_ORAINIZ,
            mininiz: item.VBT30_MININIZ,
            orafine: item.VBT30_ORAFINE,
            minfine: item.VBT30_MINFINE,
            idprog:  item.VBT30_IDPROG

        }))
    };
}

export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };

export type EmailSubmitForm = {
                emailTo?      :string;
  };



export  type Clienti = {
    idcli: string;
    label: string;
    };

export type  ClientiApiResponse = {
  results: Array<Clienti>;
  count: number;
};
export function mapJsonToClientiApiResponse(jsonData: any): ClientiApiResponse {
  const mappedData: ClientiApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      idcli: item.VBT02_IDCLI,
      label: `${item.VBT02_RAGSOCCLI} (${item.VBT02_IDCLI})`,
    }))
  };

  return mappedData;
};

